export default {
  default: () => import("/home/philip/work/general/clifton-bootcamp/layouts/default.vue")
}